<template>
  <div>
    <f7-progressbar v-if="isLoading" infinite color="green" class="progressbar-top"></f7-progressbar>
    <f7-list v-if="isLoading" class="skeleton-text skeleton-effect-wave" key="simCurrentSessionLoadSkeleton">
      <f7-list-item
          v-for="n in 4"
          :key="n"
          header="Header"
          title="Title"
      >
      </f7-list-item>
    </f7-list>

    <f7-block v-else-if="!isLoading && isNoData">
      <p>{{ $t('NoDataFound') }}</p>
    </f7-block>

    <f7-list v-else no-hairlines class="no-margin-top">
      <f7-list-item v-for="(item, index) in sessionList"
                    :key="`key-session-${index}`"
                    :title="item.value"
                    :header="item.name">
      </f7-list-item>
    </f7-list>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {QTAPI} from "../../../../services/qt-api";
import { dateFormat } from "../../../../js/helpers";

export default {
  name: "sim-current-session",

  data(){
    return {
      isLoading: false,
      isNoData: false,
      sessionList: [],
    }
  },

  computed: {
    ...mapGetters(['TargetAsset']),
  },

  mounted() {
    this.getCurrentSession()
  },

  methods: {
    async getCurrentSession(){
      this.isLoading = true;
      let result = await QTAPI.GetSimCurrentSession({ imsi: this.TargetAsset.SimNO })
      this.isLoading = false;
      if(!result){
        this.isNoData = true;
        return
      }
      console.log(result)

      this.sessionList = [
        {
          name: this.$t('IMSI'),
          value: result.imsi,
        },
        {
          name: this.$t('IMEI'),
          value: result.imei,
        },
        {
          name: this.$t('StartDate'),
          value: !result.startDateSpecified || !result.startDate ? this.$t('na') : dateFormat(result.startDate, 'datetime'),
        },
        {
          name: this.$t('UpdateDate'),
          value: !result.lastInterimDateSpecified || !result.lastInterimDate ? this.$t('na') : dateFormat(result.lastInterimDate, 'datetime'),
        },
        {
          name: this.$t('EndDate'),
          value: !result.endDateSpecified || !result.endDate ? this.$t('na') : dateFormat(result.endDate, 'datetime'),
        },
        {
          name: `${ this.$t('TotalData') } (${ this.$t('In') } / ${ this.$t('Out') })`,
          value: `${ this.numeralFormat(result.totalBytes, '0.0 b') } (${ this.numeralFormat(result.bytesIn, '0.0 b') } / ${ this.numeralFormat(result.bytesOut, '0.0 b') })`,
        },
        {
          name: this.$t('Operator'),
          value: result.networkCode,
        },
        /*{
          name: this.$t('CellInfo'),
          value: '',
        },
        {
          name: this.$t('CloseStatus'),
          value: '',
        },*/
      ]
    }
  }
}
</script>

<style scoped>

</style>